import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { HeaderComponent } from './header/header.component';

import { CommonModule } from '@angular/common';
import { SharedService } from './Services/shared.service';
import { filter } from 'rxjs';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    LoaderComponent,

    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  //title = 'mock-test';
  isShowleftMenu: boolean = false;
  isShowFooter: boolean = true;
  ExamStatus: boolean = false;
  constructor(
    public _svc: SharedService,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) {

    this._router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0);
        }
      });

    this._svc.Get_ExamStatus().subscribe(x => {
      this.ExamStatus = x;
    })
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isShowleftMenu = false;

        this.isShowFooter = true;
        if (event.url.toLocaleLowerCase() == "/exam") {
          this.isShowFooter = false;
          this._cdr.detectChanges();
        }
        this._svc.get_Login_Status().subscribe(x => {
          if (x != null) {
            if (event.url == "/" || event.url == "/login")
              this.isShowleftMenu = false;
            else
              this.isShowleftMenu = true;


          }

        })
      }
    });
  }

  onActivate(event: any) {
    // window.scroll(0,0);
    if (typeof window !== 'undefined') {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }


  }
}
